import React, { useState, useEffect } from "react";
import { If } from "react-condition";
import { officeLocations } from "../../../config";
import { useParams } from "react-router-dom";
import axios from "../../../services/axios";

import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
function TextField({
  data,
  defaultValue = null,
  isChild,
  onBlurHandler,
  isInputFieldTouched,
  approve,
  editable,
  hasChiledReadOnly,
  ocrDisabled,
  errorInputs,
}) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const refcode = searchParams.get("refcode" || "");

  const { id, ids } = useParams();
  const formId = id;
  const candidateId = ids;
  const [defValue, setDefValue] = useState("");
  const [flag, setFlag] = useState(false);
  const [element, setElement] = useState({
    type: "text",
    properties: {
      label: "Input Element",
      placeholder: "Enter Input Element here...",
      required: true,
      value: "",
    },
  });
  const [readOnly, setReadOnly] = useState(false);

  //set child to required by default -Lovejot(08-DEC-2022)
  useEffect(() => {
    let obj = { ...data };
    
    // if (isChild) {
    //   obj.properties.required = true;
    // }
    
    setElement((prev) => ({ ...prev, ...obj }));
    setFlag(!flag);

    //check prefilled field -Lovejot(07-DEC-2022)
    // if (
    //   data?.disableField === true &&
    //   data?.properties?.value &&
    //   data?.properties?.value?.length !== 0 &&
    //   localStorage.getItem("user.role") !== "admin"
    // ) {
    //   setReadOnly(true);
    // } else {
    //   setReadOnly(false);
    // }

    if (data.properties.label === "Employee Referal ID") {
      data.properties.value = refcode ? refcode : "";
      setReadOnly(true);
    }
  }, [data, isChild, refcode]);

  useEffect(() => {
    if (data?.properties?.label === "Phone Number") {
      if (data?.properties?.value) {
        setReadOnly(true);
      } else if (data?.properties?.label === "Email") {
        setReadOnly(false);
      } else {
        setReadOnly(false);
      }
    }
  }, [flag]);

  useEffect(() => {
    const labelsToCheck = [
      "IFSC Code",
      "Bank Account Number",
      "Mother's Name",
      "Father's Name",
    ];
    const currentLabel = data?.properties?.label;

    if (labelsToCheck.includes(currentLabel)) {
      const currentValue = data?.properties?.value?.trim()?.toLowerCase() || "";
      const comparisonValue = data?.comparison || "";

      if (comparisonValue !== currentValue) {
        setElement((prev) => ({ ...prev, isEdited: true }));
      } else {
        setElement((prev) => ({ ...prev, isEdited: false }));
      }
    }
  }, [data?.properties?.value]);

  const handleChange = (val) => {
    const editableLabels = [
      "Mother's Name",
      "Father's Name",
      "IFSC Code",
      "Bank Account Number",
    ];

    const currentLabel = element?.properties?.label;

    if (editableLabels.includes(currentLabel)) {
      const inputValue = val?.trim()?.toLowerCase() || "";
      const comparisonValue = element?.comparison || "";
      setElement((prev) => ({
        ...prev,
        isEdited: comparisonValue !== inputValue,
      }));
    }
  };

  const foundError = errorInputs?.find(
    (ele) => ele?.label === element?.properties?.label
  );

  console.log(element)

  return (
    <div className="form-group col-md-12 form-builder-element mb-3">
      <label htmlFor="">
        {element.properties.label}
        <If test={element.properties.required === true}>
          <span style={{ color: "red" }}>*</span>
        </If>
      </label>
      <input
        onBlur={onBlurHandler}
        readOnly={
          data?.disableField &&
          data?.properties?.value &&
          localStorage.getItem("user.role") !== "admin"
            ? data?.disableField
            : readOnly
        }
        onChange={(e) => {
          handleChange(e.target.value);
          if (isInputFieldTouched) {
            isInputFieldTouched();
          }
        }}
        disabled={
          approve ||
          !element.editable ||
          (defValue && hasChiledReadOnly) ||
          readOnly ||
          ocrDisabled
        }
        className={`form-control form-view ${
          foundError ? "border border-danger" : ""
        }`}
        type="text"
        defaultValue={defValue && isChild ? defValue : element.properties.value}
        placeholder={element.properties.placeholder}
        label={element.properties.label}
        data={JSON.stringify(element)}
        pattern={element.properties.dataType}
      />
      {foundError && <p className="text-danger">{foundError?.value}</p>}
    </div>
  );
}

export default TextField;
